// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

/* Store Custom Code - Start */
import { warrantyFormFieldStyles } from "@store/Library/Widgets/Warranty/WarrantyFormFields";
/* Store Custom Code - End */

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
    },
    /* Store Custom Code - Start */
    geolocation: {
        defaultLat: 41.757502,
        defaultLong: -71.44552,
    },
    googleMapsLibraries: ["places"],
    coolCalcStylesheets: [
        "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css",
        "https://unpkg.com/@geoman-io/leaflet-geoman-free@latest/dist/leaflet-geoman.css", // 2.15.0
        "https://cdn.coolcalc.com/leaflet-measure-path/leaflet-measure-path.css",
        "https://fonts.googleapis.com/css?family=Poppins:300,400,500,700,900&amp;display=swap",
        "https://use.fontawesome.com/releases/v5.11.2/css/all.css",
        "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css",
        "https://cdn.coolcalc.com/css/mj8/v-bootstrap/current/restui.css",
        "https://cdn.coolcalc.com/css/mj8/v-bootstrap/current/print.css",
    ],
    coolCalcFirstPassScripts: [
        "https://code.jquery.com/jquery-3.4.1.min.js",
        "https://www.gstatic.com/charts/loader.js",
        "https://unpkg.com/leaflet@1.9.0/dist/leaflet.js",
        "https://unpkg.com/leaflet.gridlayer.googlemutant@latest/dist/Leaflet.GoogleMutant.js", // 0.14.0
        "https://unpkg.com/@geoman-io/leaflet-geoman-free@latest/dist/leaflet-geoman.min.js", // 2.15.0
        "https://cdn.coolcalc.com/leaflet-measure-path/leaflet-measure-path.js",
        "https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js",
        "https://cdn.coolcalc.com/khipu-js/current/khipu.js",
        "https://cdn.coolcalc.com/javascript/mj8/shared/current/mj8.js",
        // "/dist/khipu.js", // Use commented ressources when developing locally without https certificate and port
        // "/dist/mj8.js", // Use commented ressources when developing locally without https certificate and port
    ],
    coolCalcSecondPassScripts: [
        "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js",
        "https://code.jquery.com/ui/1.12.1/jquery-ui.min.js",
        "https://cdn.coolcalc.com/javascript/map-trace/current/mt-widget.js",
        // "/dist/mt-widget.js", // Use commented ressources when developing locally without https certificate and port
        "https://cdn.coolcalc.com/javascript/mj8/v-bootstrap/current/tools.js",
        "https://cdn.coolcalc.com/khipu-callbacks/mj8/v-bootstrap/current/khipu-callbacks.js",
    ],
    widgetGroup: {
        partFinder: "Part Finder" as any,
    },
    availability: {
        notAvailable: "NotAvailable",
    },
    roles: {
        pointOfSale: "DCNE_PointOfSale",
    },
    sourcingTypes: {
        warehouseTransfer: "WarehouseTransfer",
        directTransfer: "DirectTransfer",
        warehousePurchaseOrder: "WarehousePurchaseOrder",
        directPurchaseOrder: "DirectPurchaseOrder",
    },
    allowedCounterSaleWarehouseOverrides: ["MALD", "AVON"],
    warrantyFormFields: {
        baseUnitInstallDate: { label: "Base Unit Install Date", placeholder: "Base Unit Install Date", required: true },
        signedName: { label: "Name", placeholder: "Name", required: true },
        baseUnitModelNumber: { label: "Base Unit Model Number", placeholder: "Base Unit Model Number", required: true },
        baseUnitSerialNumber: {
            label: "Base Unit Serial Number",
            placeholder: "Base Unit Serial Number",
            required: true,
        },
        clientEmail: {
            label: "Email",
            placeholder: "e.g. name@example.com",
            required: true,
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            regexErrorMessage: "Invalid email format. Use name@example.com",
        },
        companyCity: { label: "Company City", placeholder: "Company City", required: true },
        companyName: { label: "Company Name", placeholder: "Company Name", required: true },
        companyPhone: {
            label: "Company Phone",
            placeholder: "e.g. 123 456 7890 or +1 (123) 456-7890 ext123",
            required: true,
            regex: /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}(?:\s?(?:ext\.?|x)\s?\d{1,5})?$/,
            regexErrorMessage: "Invalid format. Use 123 456 7890 or +1 (123) 456-7890 ext123",
        },
        companySt: { label: "Company State", placeholder: "Company State", required: true },
        companyStreet: { label: "Company Street", placeholder: "Company Street", required: true },
        companyZip: {
            label: "Company Zip",
            placeholder: "e.g. 12345 or 12345-6789",
            required: true,
            regex: /^\d{5}(-\d{4})?$/,
            regexErrorMessage: "Invalid format. Use 12345 or 12345-6789",
        },
        dcneAccountNumber: { label: "DCNE Account Number", placeholder: "DCNE Account Number", required: true },
        diagnosisBulletinNumber: {
            label: "Diagnosis Bulletin Number",
            placeholder: "Diagnosis Bulletin Number",
            required: false,
        },
        failDate: { label: "Fail Date", placeholder: "Fail Date", required: true },
        jobSiteName: { label: "Job Site Name", placeholder: "Job Site Name", required: true },
        jobSiteStreet: { label: "Job Site Street", placeholder: "Job Site Street", required: true },
        jobSiteCity: { label: "Job Site City", placeholder: "Job Site City", required: true },
        jobSiteSt: { label: "Job Site State", placeholder: "Job Site State", required: true },
        jobSiteZip: {
            label: "Job Site Zip",
            placeholder: "e.g. 12345 or 12345-6789",
            required: true,
            regex: /^\d{5}(-\d{4})?$/,
            regexErrorMessage: "Invalid format. Use 12345 or 12345-6789",
        },
        jobSitePhone: {
            label: "Job Site Phone",
            placeholder: "e.g. 123 456 7890 or +1 (123) 456-7890 ext123",
            required: true,
            regex: /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)\d{3}[\s.-]?\d{4}(?:\s?(?:ext\.?|x)\s?\d{1,5})?$/,
            regexErrorMessage: "Invalid format. Use 123 456 7890 or +1 (123) 456-7890 ext123",
        },
        reasonForRepairFailure: {
            label: "Reason for Repair Failure",
            placeholder: "Reason for Repair Failure",
            required: true,
        },
        repairCompleteDate: { label: "Repair Complete Date", placeholder: "Repair Complete Date", required: true },
        replacementDcneInvoiceNumber: {
            label: "Replacement DCNE Invoice Number",
            placeholder: "Replacement DCNE Invoice Number",
            required: true,
        },
        replacementPartWarrantyDate: {
            label: "Replacement Part Warranty Date",
            placeholder: "Replacement Part Warranty Date",
            requiredParentFieldKey: "selectedWarrantyType",
            requiredParentFieldValue: "ReplacementPartWarranty",
            required: true,
        },
        replacementPartWarrantyInvoiceNumber: {
            label: "Replacement Part Warranty Invoice Number",
            placeholder: "Replacement Part Warranty Invoice Number",
            requiredParentFieldKey: "selectedWarrantyType",
            requiredParentFieldValue: "ReplacementPartWarranty",
            required: true,
        },
        submittedFormDate: { label: "Submitted Form Date", placeholder: "Submitted Form Date", required: true },

        // Failed Part Numbers
        failedPartNumber1: {
            label: "Failed Part Number",
            placeholder: "Failed Part Number",
            required: true,
        },
        failedPartNumber2: {
            label: "Failed Part Number 2",
            placeholder: "Failed Part Number 2",
            groupValidation: "product2",
            required: true,
        },
        failedPartNumber3: {
            label: "Failed Part Number 3",
            placeholder: "Failed Part Number 3",
            groupValidation: "product3",
            required: true,
        },
        failedPartNumber4: {
            label: "Failed Part Number 4",
            placeholder: "Failed Part Number 4",
            groupValidation: "product4",
            required: true,
        },
        failedPartNumber5: {
            label: "Failed Part Number 5",
            placeholder: "Failed Part Number 5",
            groupValidation: "product5",
            required: true,
        },
        failedPartNumber6: {
            label: "Failed Part Number 6",
            placeholder: "Failed Part Number 6",
            groupValidation: "product6",
            required: true,
        },
        failedPartNumber7: {
            label: "Failed Part Number 7",
            placeholder: "Failed Part Number 7",
            groupValidation: "product7",
            required: true,
        },
        failedPartNumber8: {
            label: "Failed Part Number 8",
            placeholder: "Failed Part Number 8",
            groupValidation: "product8",
            required: true,
        },
        failedPartNumber9: {
            label: "Failed Part Number 9",
            placeholder: "Failed Part Number 9",
            groupValidation: "product9",
            required: true,
        },
        failedPartNumber10: {
            label: "Failed Part Number 10",
            placeholder: "Failed Part Number 10",
            groupValidation: "product10",
            required: true,
        },
        failedQty1: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            required: true,
        },
        failedQty2: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product2",
            required: true,
        },
        failedQty3: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product3",
            required: true,
        },
        failedQty4: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product4",
            required: true,
        },
        failedQty5: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product5",
            required: true,
        },
        failedQty6: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product6",
            required: true,
        },
        failedQty7: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product7",
            required: true,
        },
        failedQty8: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product8",
            required: true,
        },
        failedQty9: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product9",
            required: true,
        },
        failedQty10: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product10",
            required: true,
        },

        // Failed Serial Numbers
        failedSerialNumber1: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            required: true,
        },
        failedSerialNumber2: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product2",
            required: true,
        },
        failedSerialNumber3: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product3",
            required: true,
        },
        failedSerialNumber4: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product4",
            required: true,
        },
        failedSerialNumber5: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product5",
            required: true,
        },
        failedSerialNumber6: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product6",
            required: true,
        },
        failedSerialNumber7: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product7",
            required: true,
        },
        failedSerialNumber8: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product8",
            required: true,
        },
        failedSerialNumber9: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product9",
            required: true,
        },
        failedSerialNumber10: {
            label: "Failed Serial Number",
            placeholder: "Failed Serial Number",
            groupValidation: "product10",
            required: true,
        },

        // Failed Replacement Part Numbers
        failedReplacementPartNumber1: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",

            required: true,
        },
        failedReplacementPartNumber2: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product2",
            required: true,
        },
        failedReplacementPartNumber3: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product3",
            required: true,
        },
        failedReplacementPartNumber4: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product4",
            required: true,
        },
        failedReplacementPartNumber5: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product5",
            required: true,
        },
        failedReplacementPartNumber6: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product6",
            required: true,
        },
        failedReplacementPartNumber7: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product7",
            required: true,
        },
        failedReplacementPartNumber8: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product8",
            required: true,
        },
        failedReplacementPartNumber9: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product9",
            required: true,
        },
        failedReplacementPartNumber10: {
            label: "Failed Replacement Part Number",
            placeholder: "Failed Replacement Part Number",
            groupValidation: "product10",
            required: true,
        },

        // Failed Replacement Serial Numbers
        failedReplacementSerialNumber1: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",

            required: true,
        },
        failedReplacementSerialNumber2: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product2",
            required: true,
        },
        failedReplacementSerialNumber3: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product3",
            required: true,
        },
        failedReplacementSerialNumber4: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product4",
            required: true,
        },
        failedReplacementSerialNumber5: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product5",
            required: true,
        },
        failedReplacementSerialNumber6: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product6",
            required: true,
        },
        failedReplacementSerialNumber7: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product7",
            required: true,
        },
        failedReplacementSerialNumber8: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product8",
            required: true,
        },
        failedReplacementSerialNumber9: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product9",
            required: true,
        },
        failedReplacementSerialNumber10: {
            label: "Failed Replacement Serial Number",
            placeholder: "Failed Replacement Serial Number",
            groupValidation: "product10",
            required: true,
        },
        failedReplacementQty1: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            required: true,
        },
        failedReplacementQty2: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product2",
            required: true,
        },
        failedReplacementQty3: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product3",
            required: true,
        },
        failedReplacementQty4: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product4",
            required: true,
        },
        failedReplacementQty5: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product5",
            required: true,
        },
        failedReplacementQty6: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product6",
            required: true,
        },
        failedReplacementQty7: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product7",
            required: true,
        },
        failedReplacementQty8: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product8",
            required: true,
        },
        failedReplacementQty9: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product9",
            required: true,
        },
        failedReplacementQty10: {
            label: "Qty",
            regex: /^\d+$/,
            regexErrorMessage: "Numbers only",
            placeholder: "Qty",
            groupValidation: "product10",
            required: true,
        },
        // Types Dropdown
        selectedWarrantyType: {
            label: "Warranty Type",
            placeholder: "",
            required: true,
        },
    },
    /* Store Custom Code - End */
});
